import React from 'react';
import DelaCardComponent from '../components/DelaCardComponent'
import '../cardgrid.css';
import BaseSizeSensitiveComponent from "../components/BaseSizeSensitiveComponent";

class PlatformsBox extends BaseSizeSensitiveComponent {

    render() {

    var cardGrid = {
            marginTop: 20,
            display: "flex",
            justifyContent: "center",
            flexWrap: "wrap"
        }

    var cardGridItem = {
            border: "1px solid #fff",
            margin: 10
        }

        return (
            <div style={this.styler.currStyles.Card.grid}>
                <div style={this.styler.currStyles.Card.gridItem}>
                    <DelaCardComponent
                        image="/assets/Mobile-App-developers2.jpg"
                        style={this.styler.currStyles.Card}
                        width="289"
                        title="Mobile"
                        subtitle="Android / iOS / Hybrid"
                        description="I can develop both native and hybrid mobile apps."
                        pushTo="/platforms/mobile"
                    />
                </div>
                <div style={this.styler.currStyles.Card.gridItem}>
                    <DelaCardComponent
                        image="/assets/cloud-server-resized.png"
                        style={this.styler.currStyles.Card}
                        width="289"
                        title="Server / Cloud"
                        subtitle="Linux / Windows / Cloud"
                        pushTo="/platforms/servercloud"
                    />
                </div>
                <div style={this.styler.currStyles.Card.gridItem}>
                    <DelaCardComponent
                        image="/assets/desktop.png"
                        style={this.styler.currStyles.Card}
                        width="289"
                        title="Desktop"
                        subtitle="Windows / macOS / *nix"
                        pushTo="/platforms/desktop"
                    />
                </div>
                <div style={this.styler.currStyles.Card.gridItem}>
                    <DelaCardComponent
                        image="/assets/web.png"
                        style={this.styler.currStyles.Card}
                        width="289"
                        title="Web"
                        subtitle="ASP.NET / Node.js"
                        pushTo="/platforms/web"
                    />
                </div>
                <div style={this.styler.currStyles.Card.gridItem}>
                    <DelaCardComponent
                        image="/assets/IoT.png"
                        style={this.styler.currStyles.Card}
                        width="289"
                        title="Embedded"
                        subtitle="PIC / ARM / x86"
                        pushTo="/platforms/embeddediot"
                    />
                </div>
            </div>
        );
    }
}

export default PlatformsBox


// WEBPACK FOOTER //
// src/SkillsAndExperience/PlatformsBox.js